import { Position } from "@blueprintjs/core"
import React from "react"
import { useNavigate, useLocation } from "react-router-dom"
import ActionMenu from "components/Organisms/ActionMenu"
import ActionMenuItem from "components/Organisms/ActionMenuItem"
import qs from "query-string"
const TableActionsButton = props => {
  const navigate = useNavigate()
  const location = useLocation()
  const { type } = qs.parse(location.search)

  function handleClick(type) {
    switch (type) {
      case "sellable-item":
        navigate("/d/ecom/approval-stock-take?type=sellable-item")
        return
      case "rpg":
        navigate("/d/ecom/approval-stock-take?type=rpg")
        return
      case "raw-material":
        navigate("/d/ecom/approval-stock-take?type=raw-material")
        return
      default:
        return
    }
  }

  return (
    <>
      <ActionMenu
        onClick={handleClick}
        popoverProps={{
          position: Position.BOTTOM_RIGHT,
        }}
        text={
          type === "rpg"
            ? "RPG"
            : type === "raw-material"
            ? "Raw material"
            : "Sellable item"
        }
        icon={null}
        rightIcon="caret-down"
        dark={true}
        {...props}
      >
        <ActionMenuItem text="Sellable item" id="sellable-item" />
        <ActionMenuItem text="RPG" id="rpg" />
        <ActionMenuItem text="Raw material" id="raw-material" />
      </ActionMenu>
    </>
  )
}

export default TableActionsButton
